var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_8437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 13.7499V1.83325M11 1.83325L13.75 5.04159M11 1.83325L8.25 5.04159",
    stroke: "#808080",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 20.1668H14.6673C17.26 20.1668 18.5564 20.1668 19.3618 19.3613C20.1673 18.5559 20.1673 17.2595 20.1673 14.6668V13.7501C20.1673 11.1574 20.1673 9.86105 19.3618 9.05558C18.6575 8.35122 17.5777 8.26281 15.584 8.25171M6.41732 8.25171C4.42354 8.26281 3.34379 8.35122 2.63944 9.05557C1.83398 9.86105 1.83398 11.1574 1.83398 13.7501V14.6668C1.83398 17.2595 1.83398 18.5559 2.63944 19.3613C2.91426 19.6361 3.24622 19.8172 3.66732 19.9365",
    stroke: "#808080",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_8437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.c03020d3be03f0d6fc7b4382ddea72d4.svg";
export { ForwardRef as ReactComponent };